module.exports = __webpack_public_path__ + "media/images/emoticons/enter-7659d93b386d9e64aa135065391de88f.gif";